import styled from 'styled-components'
import { BurgerMenu } from 'components/Molecules/BurgerMenu'
import { config } from 'config/index'
import { SKINS } from 'constants/skins'

const { APP_SKIN_VERSION } = config

const hideHamburger = [SKINS.WSB].includes(APP_SKIN_VERSION)

export const Menu = () => {
  if (hideHamburger) return null
  return (
    <MenuArea>
      <BurgerMenu variant='game' />
    </MenuArea>
  )
}

const MenuArea = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
